import { useState } from "react";
import { useDispatch } from "react-redux";
import { sortBySalary } from "../../features/filter/filterSlice";

const Sort = () => {
    const [value, setValue] = useState("");

    const dispatch = useDispatch();

    const handleChange = (e) => {
        setValue(e.target.value);
        dispatch(sortBySalary(e.target.value));
    };

    return (
        <select
            id="lws-sort"
            name="sort"
            autoComplete="sort"
            className="flex-1"
            value={value}
            onChange={handleChange}
        >
            <option>Default</option>
            <option>Salary (Low to High)</option>
            <option>Salary (High to Low)</option>
        </select>
    );
};

export default Sort;
